(function () {
  "use strict";

  CustomCertificateCtrl.$inject = ['$scope', 'resolveData', '$route', 'modalHelper', 'mtypes', '$location', 'customCertificateResource', '$window', '$timeout', 'trainerPrivilege', 'fileUpload'];
  angular
    .module('trainerWebApp.controllers')
    .controller('CustomCertificateCtrl', CustomCertificateCtrl);

  function CustomCertificateCtrl($scope, resolveData, $route, modalHelper, mtypes, $location, customCertificateResource, $window, $timeout, trainerPrivilege, fileUpload) {
    var courseId = $route.current.params.courseId;
    var seriesId = $route.current.params.seriesId;
    var userRole = trainerPrivilege.roles();
    var queryParams = $location.search();

    if(!queryParams.series && !queryParams.course) {
      if (!~$window.mfConfig.features.indexOf(mtypes.featureEntry.customCertificate) || !userRole.canEditCourses) {
        if (courseId) {
          $location.path('/TMS/Distribute_Course/' + courseId);
        } else {
          $location.path('/TMS/Series/' + seriesId);
        }
        return;
      }
    }

    $window.document.title = "Custom Certificate | Mindflash Training Management System";

    $scope.initialized = false;

    $scope.uploadParameters = {
      // Only allow these file extension for upload
      accept: ['.jpg', '.jpeg', '.png'],
      transformations: {
        crop: {
            aspectRatio: 1.3,
            force: true
        }        
      },
      fromSources: ['local_file_system', 'webcam']
    };

    var customFields = _.sortBy(resolveData.customFields, function (field) {
      return field.name;
    });
    var trainees = _.sortBy(resolveData.trainees, function (item) {
      return item.lastName + ' ' + item.firstName;
    });

    var searchTrainees = _.map(trainees, function (item) {
      return {
        id: item.id,
        text: item.lastName + ' ' + item.firstName
      };
    });


    $scope.resizeScale = 1;

    $scope.resizeContainers = function (scale) {
      $scope.resizeScale = scale;
      $scope.centralFieldContainerStyle = {
        top: (70 * $scope.resizeScale) + "px",
        bottom: (205 * $scope.resizeScale) + "px"
      };

      $scope.bottomFieldContainerStyle = {
        bottom: (119 * $scope.resizeScale) + "px",
        left: (110 * $scope.resizeScale) + "px",
        right: (110 * $scope.resizeScale) + "px",
        height: (80 * $scope.resizeScale) + "px"
      };
    };

    $scope.uploadBackgroundImageButton = function() {
      fileUpload.pick($scope.uploadParameters).then($scope.processFileUpload);
    };

    $scope.processFileUpload = function(outcome) {
      if (outcome.success) {
        customCertificateResource.saveBackgroundImage({
          courseId: courseId || seriesId,
          url: outcome.data.fileUrl,
          filename: outcome.data.fileName
        }, function (result) {
          onUploadComplete({
            fileUrl: outcome.data.fileUrl,
            fileId: result.contentFileId
          });
        });
      }
    };

    $scope.viewModel = {
      fieldValues: [],
      selectedTrainee: null,
      backgroundImageUrl: null,
      backgroundFileId: 0,
      uploading: false,
      isCourse: courseId > 0,
      isDirty: false,
      title: courseId > 0 ? "Untitled Course" : "Untitled Series",
      certificateFields: [
        {
          type: null,
          text: "",
          pdfPlaceholderName: 'placeholder1',
          showWarning: false,
          isDirty: false
        },
        {
          type: null,
          text: "",
          pdfPlaceholderName: 'placeholder2',
          showWarning: false,
          isDirty: false
        },
        {
          type: null,
          text: "",
          pdfPlaceholderName: 'placeholder3',
          showWarning: false,
          isDirty: false
        },
        {
          type: null,
          text: "",
          pdfPlaceholderName: 'placeholder4',
          showWarning: false,
          isDirty: false
        },
        {
          type: null,
          text: "",
          pdfPlaceholderName: 'placeholder5',
          showWarning: false,
          isDirty: false
        },
        {
          type: null,
          text: "",
          pdfPlaceholderName: 'placeholder6',
          showWarning: false,
          isDirty: false
        },
        {
          type: null,
          text: "",
          pdfPlaceholderName: 'placeholder7',
          showWarning: false,
          isDirty: false
        },
        {
          type: null,
          text: "",
          pdfPlaceholderName: 'placeholder8',
          showWarning: false,
          isDirty: false
        },
        {
          type: null,
          text: "",
          pdfPlaceholderName: 'placeholder9',
          showWarning: false,
          isDirty: false
        },
        {
          type: null,
          text: "",
          pdfPlaceholderName: 'placeholder10',
          showWarning: false,
          isDirty: false
        },
        {
          type: null,
          text: "",
          pdfPlaceholderName: 'placeholder11',
          showWarning: false,
          isDirty: false
        }
      ]
    };

    $scope.viewModel.topFields = _.first($scope.viewModel.certificateFields, 6);
    $scope.viewModel.bottomFields = _.last($scope.viewModel.certificateFields, 5);

    $scope.selectTraineeOptions = {
      width: '100%',
      multiple: true,
      minimumInputLength: 0,
      maximumInputLength: 40,
      data: searchTrainees,
      allowClear: true,
      placeholder: 'Type the name of any trainee'
    };

    $scope.uploadSettings = {
      upload_url: '/TrainerGS/UploadCustomCertificateBackground',
      button_width: 185,
      button_height: 30,
      file_types: '*.jpg;*.png',
      file_types_description: 'Images',
      post_params: {
        courseID: courseId || seriesId,
        sessId: mfConfig.sessionId
      },
      upload_success_handler: function (file, result) {
        var info = JSON.parse(result);

        if (info.error) {
          $scope.onUploadStatusChange('processingError', info);
          return modalHelper.messageBox({title: 'Error Processing Image', message: info.error}).result;
        }

        $scope.onUploadStatusChange('success', info);
      }
    };

    $scope.uploadProgressStyle = {width: '0%'};

    $scope.onUploadStatusChange = function (status, info) {
      if (status === 'success') {
        $scope.uploadProgressStyle.width = '100%';
        return onUploadComplete(info);
      }

      if (~['uploading', 'processing'].indexOf(status)) {
        $scope.uploadProgressStyle.width = info + '%';
        return $scope.viewModel.uploading = true;
      }
      $scope.viewModel.uploading = false;
    };

    function onUploadComplete(info) {
      if (info.fileUrl) {
        $scope.viewModel.backgroundImageUrl = info.fileUrl;
        $scope.viewModel.backgroundStyle = {background: '#FFFFFF'};
        $scope.viewModel.backgroundFileId = info.fileId;
        $scope.viewModel.isDirty = true;
      }

      $scope.viewModel.uploading = false;

      if (!$scope.$root.$$phase)
        $scope.$apply();
    }

    $scope.onUploadStatusChange();

    fillFieldsValues();

    function fillFieldsValues() {
      $scope.viewModel.fieldValues = [];

      $scope.viewModel.fieldValues.push({name: 'Trainee Name', type: mtypes.customCertificateField.traineeName});
      $scope.viewModel.fieldValues.push({name: 'Company Name', type: mtypes.customCertificateField.companyName});
      $scope.viewModel.fieldValues.push({
        name: 'Training Score',
        type: mtypes.customCertificateField.courseScore
      });
      $scope.viewModel.fieldValues.push({
        name: 'Training Name',
        type: mtypes.customCertificateField.courseName
      });
      $scope.viewModel.fieldValues.push({name: 'Completion Date', type: mtypes.customCertificateField.completionDate});
      $scope.viewModel.fieldValues.push({name: 'Trainer Name', type: mtypes.customCertificateField.trainerName});
      $scope.viewModel.fieldValues.push({name: 'Blank', type: mtypes.customCertificateField.blank});
      $scope.viewModel.fieldValues.push({name: 'Text Field', type: mtypes.customCertificateField.textField});


      var customFieldIndex = [];
      _.each(customFields, function (field) {
        $scope.viewModel.fieldValues.push({
          name: field.name,
          type: mtypes.customCertificateField.customField + '|' + field.fieldIndex
        });
        customFieldIndex.push(field.fieldIndex);
      });

      if (resolveData.customCertificate) {
        var certificate = resolveData.customCertificate;

        var certificateFields = _.filter(certificate.certificateFields, function (f) {
          return f.type != mtypes.customCertificateField.customField || _.contains(customFieldIndex, f.customFieldIndex);
        });

        $scope.viewModel.backgroundFileId = certificate.backgroundImageId || 0;
        $scope.viewModel.backgroundImageUrl = certificate.backgroundImageUrl || null;
        if (certificate.backgroundImageUrl) {
          $scope.viewModel.backgroundStyle = {background: '#FFFFFF'};
        }


        _.each(certificateFields, function (f) {
          var field = _.find($scope.viewModel.certificateFields, function (item) {
            return item.pdfPlaceholderName.toLowerCase() == f.pdfPlaceholderName.toLowerCase();
          });

          if (f.type == mtypes.customCertificateField.customField) {
            field.type = f.type + '|' + f.customFieldIndex;
          } else {
            field.type = f.type;
          }

          field.text = f.text;
        });

        clearAllIsDirtyFlags();

        if (resolveData.courseInfo && resolveData.courseInfo.certificateTemplate != mtypes.certificateTemplate.custom) {
          $scope.viewModel.isDirty = true;
        }
      }

      if (resolveData.courseInfo && resolveData.courseInfo.name && resolveData.courseInfo.name.length > 0)
        $scope.viewModel.title = resolveData.courseInfo.name;
    }

    $scope.cancel = function () {
      if(queryParams.series) {
        $window.location.href = '/TrainerM/#/series/' + seriesId + '/settings';
      } else if (queryParams.course) {
        $window.location.href = '/TrainerM/#/courses/' + courseId + '/settings';
      } else if (queryParams.liveTraining) {
        $window.location.href = '/TrainerM/#/liveTrainings/' + courseId + '/settings';
      } else if ($scope.viewModel.isCourse) {
        $location.path('/TMS/Customize_Settings/' + courseId);
      } else {
        $location.path('/TMS/Series/' + seriesId + '/customize');
      }
    };

    $scope.fieldChange = function (field) {
      if (checkFieldIsDirty(field)) {
        field.isDirty = true;
      }
      checkDuplicateSelections();
    };

    function checkFieldIsDirty(field) {

      if (field.last) {

        if (field.last.type != field.type) {
          return true;
        }
        if (field.type == mtypes.customCertificateField.textField && field.last.text != field.text) {
          return true;
        }

        return false;
      }

      return true;
    }

    function checkDuplicateSelections() {
      var counted = _.countBy($scope.viewModel.certificateFields, function (i) {
        return i.type || 'all';
      });

      _.each($scope.viewModel.certificateFields, function (item) {
        item.showWarning = false;
      });
      _.each(counted, function (value, key, list) {
        if (warnIfDuplicated(key, value)) {
          _.each(_.filter($scope.viewModel.certificateFields, function (i) {
            return i.type == key;
          }), function (item) {
            item.showWarning = true;
          });
        }
      });
    }

    function warnIfDuplicated(key, value) {
      if (key == 'all') {
        return false;
      }
      if (key == mtypes.customCertificateField.blank) {
        return false;
      }
      if (key == mtypes.customCertificateField.textField) {
        return false;
      }
      return value > 1;
    }

    $scope.apply = function () {
      customCertificateResource.saveCustomCertificate(getCurrentCertificateData(), function (result) {
        clearAllIsDirtyFlags();
      });
    };

    function getCurrentCertificateData() {
      return {
        courseId: courseId || seriesId,
        backgroundImageId: $scope.viewModel.backgroundFileId,
        certificateFields: _.map(_.filter($scope.viewModel.certificateFields, function (t) {
          return !!t.type;
        }), function (f) {
          var typeParts = f.type.toString().split('|');

          var result = {
            pdfPlaceholderName: f.pdfPlaceholderName,
            type: parseInt(typeParts.length > 1 ? typeParts[0] : f.type)
          };

          if (result.type == mtypes.customCertificateField.textField) {
            result.textValue = f.text;
          }

          if (result.type == mtypes.customCertificateField.customField) {
            result.customFieldIndex = parseInt(typeParts[1]);
          }

          return result;
        })
      };
    }

    function clearAllIsDirtyFlags() {
      _.each($scope.viewModel.certificateFields, function (f) {
        f.isDirty = false;
        f.last = _.clone(f);
      });
      $scope.viewModel.isDirty = false;
    }

    $scope.canApply = function () {
      if ($scope.viewModel.isDirty) {
        return true;
      }

      return _.any($scope.viewModel.certificateFields, function (i) {
        return i.isDirty;
      });
    };

    $scope.$on('$destroy', function () {
      // TODO: Cleanup...
    });

    $scope.downloadTemplateUrl = "/TrainerGS/DownloadCertificateTemplate";

    if (~$window.mfConfig.features.indexOf(mtypes.featureEntry.mmReportCertificateGeneration)) {
      $scope.downloadTemplateUrl = "/Certificates/customTraineeCertificateTemplatedownload";
    }

    $scope.downloadPdfPreview = function () {
      customCertificateResource.saveCustomCertificate(getCurrentCertificateData(), function (result) {
        clearAllIsDirtyFlags();

        var url = "/Certificates/CertificatePreview.aspx?c=" + (courseId || seriesId) + "&qs=83&pm=ocdPreview&t=130000400";
        var userId = 0;

        if ($scope.viewModel.selectedTrainee) {
          if (angular.isArray($scope.viewModel.selectedTrainee)) {
            userId = $scope.viewModel.selectedTrainee.length ? $scope.viewModel.selectedTrainee[0].id : 0;
          } else {
            userId = $scope.viewModel.selectedTrainee;
          }
        }
        if (userId > 0)
          url += "&u=" + userId;

        $timeout(function () {
          $window.location = url;
        }, 0);
      });
    };
  }

})();
